import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faTimes } from "@fortawesome/free-solid-svg-icons";
import "./cartPage.css";
import "./media_recycle_cart.css";
import "../../components/common/style.css";
import "../../components/common/responsive.css";
import Header from "../../components/common/header";
import Footer from "../../components/common/footer";
import sellmartBulkImage from "../../assets/images/Frame 20.png";
import voucherIconImage from "../../assets/images/Voucher_icon.png";
import trashIcon from "../../assets/images/Group 239187.png";
import { useUser } from "../../contexts/userContext";
import { useCart } from "../../contexts/cartContext";
import { Modal } from "bootstrap";

interface CartItem {
  item_id: string;
  product_id: number;
  title: string;
  img_name: string;
  evaluated_value: string;
  quantity: number;
  base_value: string;
  brand: string;
  brands: any;
  productCat: any;
  productParent: any;
  attributes: any;
  image_alt_tag: string;
}

type OfferData = {
  block_id: number;
  code: string;
  title: string;
  html_content: string;
  is_active: number;
};

interface FlashMessageProps {
  message: string;
  onClose: () => void;
}

// const FlashMessage = ({ message }: { message: string }) => {
//   return (
//     <div
//       style={{
//         position: "fixed",
//         top: "10px",
//         left: "50%",
//         transform: "translateX(-50%)",
//         backgroundColor: "red",
//         color: "white",
//         padding: "10px 20px",
//         borderRadius: "5px",
//         zIndex: 1000,
//       }}
//     >
//       {message}
//     </div>
//   );
// };


const CartPage = () => {
  const navigate = useNavigate();
  const [showFlashMessage, setShowFlashMessage] = useState(false);
  const [cartItems, setCartItems] = useState<CartItem[]>([]);
  const [topOffersData, setTopOffersData] = useState<OfferData | null>(null);
  const [topVouchersData, setTopVouchersData] = useState<OfferData | null>(
    null
  );
  const [cartId, setCartId] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [feesShow, setFeeShow] = useState<boolean | null>(false);
  const [errorQty, setErrorQty] = useState<string | null>(null);
  const [pickupFees, setPickupFees] = useState<string | null>(null);
  const [globalpickupFees, setGlobalPickupFees] = useState<string | null>(null);
  const [totalValue, setTotalValue] = useState<number | null>(null);
  const [totalQuantity, setTotalQuantity] = useState<number>(0); // State for total quantity
  const [showModal, setShowModal] = useState(false);
  const [brands, setBrands] = useState<{ [key: number]: any[] }>({});
  const [itemToRemove, setItemToRemove] = useState<number | null>(null);
  const [selectedBrands, setSelectedBrands] = useState<{
    [key: string]: string | null;
  }>({});
  const [dropdownOpen, setDropdownOpen] = useState<{ [key: string]: boolean }>(
    {}
  );
  const [brandTitle, setBrandTitle] = useState<string | null>(null);
  const [brandError, setBrandError] = useState<Record<string, boolean>>({});
  const [selectedItemId, setSelectedItemId] = useState<number | null>(null);
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const version = process.env.REACT_APP_VERSION;
  const location = useLocation();
  const userId = location.state?.user_id;
  const product = location.state?.product;
  const {
    user_id,
    auth_token,
    sess_code,
    checkSessionTokenExpirationStatus,
    handleRemoveLocalStorage,
    fetchCsrfToken
  } = useUser();

  const [vouchersData, setVouchersData] = useState([]);
  const [selectedVouchers, setSelectedVouchers] = useState<any[]>([]);
  const [voucherMoreDescriptionStatus, setVoucherMoreDescriptionStatus] =
    useState({});
  const [voucherPopupVisible, setVoucherPopupVisible] = useState(false);
  const [itemVoucherApplied, setItemVoucherApplied] = useState({});
  const [applyVoucherButton, setApplyVoucherButton] = useState(false);
  const [appliedCartItemVoucher, setAppliedCartItemVoucher] = useState([]);
  const [
    removeItemLevelVoucherPopUpStatus,
    setRemoveItemLevelVoucherPopUpStatus,
  ] = useState(false);
  const [removeVoucherPerItemData, setRemoveVoucherPerItemData] = useState<any>(
    {}
  );
  const [
    removeAllItemLevelVoucherPopUpStatus,
    setRemoveAllItemLevelVoucherPopUpStatus,
  ] = useState(false);
  const [appliedDummyVoucherData, setAppliedDummyVoucherData] = useState<any>(
    []
  );
  const [moreButtonIndex, setMoreButtonIndex] = useState<any>(null);
  const [
    removeOrderLevelVoucherPopUpStatus,
    setRemoveOrderLevelVoucherPopUpStatus,
  ] = useState(false);
  const [
    itemOrOrderVoucherSelectionError,
    setItemOrOrderVoucherSelectionError,
  ] = useState("");
  const [cashValueStatus, setCashValueStatus] = useState(false);
  const [cashValueAmount, setCashValueAmount] = useState<any>(null);
  const [voucherValueAmount, setVoucherValueAmount] = useState<any>(null);
  const [voucherValueStatus, setVoucherValueStatus] = useState(false)
  const [pickupFeesAppliedVoucherStatus, setPickupFeesAppliedVoucherStatus] = useState(false);
  const [orderVoucherValueStatus, setOrderVoucherValueStatus] = useState(false)
  const { fetchCartQuantity, cartQuantity, setCartQuantity, handleQuantity, getBannerOrImageAltTag } = useCart();
  const {
    setcityName,
    globalSearchTerm,
    setGlobalSearchTerm,
    setSessionCode,
    setUserId,
    setUsername,
    setUtmSessionId
  } = useUser();
  //console.log("cart----00000000000-----", location.state);
  const utmQuery = location.state?.utmQuery;

  useEffect(() => {
    if (!user_id) {
      navigate("/sell-used-appliances");
    }
    document
      .querySelectorAll(".modal-backdrop")
      .forEach((backdrop) => backdrop.remove());
    fetchCartQuantity(sess_code || "defaultSessionCode");
    fetchCartItems();
    fetchCartId();
    //console.log("cart listing page utmQuery", utmQuery);
  }, [sess_code]);

  const sessionCode = sess_code;
  const fetchBrands = async (parent_cat_id: number) => {
    try {
      const response = await fetch(
        `${backendUrl}api/v2/brands/${parent_cat_id}`,
        {
          method: 'GET',
          headers: {
            // Accept:'aplication/json',
            "Content-Type": "application/json",

          },
          credentials: "include",
          mode: "cors"
        }
      );

      const login = localStorage.getItem("isLoggedIn")

      if (login !== 'true') {
        setError("Access forbidden: You don't have permission to view cart items.");
        localStorage.clear()
        sessionStorage.clear()
        setCartQuantity(0)
        setShowFlashMessage(true);
        setTimeout(() => {
          navigate("/sell-used-appliances");
        }, 3000); // Redirect to login if unauthorized
        return;
      }
      const result = await response.json();
      if (result.data.length > 0) {
        setBrands((prev) => ({
          ...prev,

          [parent_cat_id]: result.data,
        }));
      } else {
        setBrands((prev) => ({
          ...prev,

          [parent_cat_id]: [], // Ensure empty array if no brands
        }));
      }
    } catch (error) {
      //console.error("Error fetching brands:", error);
    }
  };

  const FlashMessage: React.FC<FlashMessageProps> = ({ message, onClose }) => {
    useEffect(() => {
      const timer = setTimeout(() => {
        onClose(); // Hide the flash message after 5 seconds
      }, 3000);

      return () => clearTimeout(timer); // Cleanup on unmount
    }, [onClose]);

    return (
      <div
        style={{
          position: "fixed",
          top: "0",
          left: "0",
          width: "100vw",
          height: "100vh",
          backgroundColor: "rgba(0, 0, 0, 0.3)", // Semi-transparent background
          backdropFilter: "blur(10px)", // Blur effect
          WebkitBackdropFilter: "blur(10px)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 999, // Ensure it appears above other content

        }}
      >
        <div
          style={{
            backgroundColor: "#db5f5f",
            color: "white",
            padding: "10px 20px",
            borderRadius: "5px",
            zIndex: 1000, // Ensure it's on top of blur
            boxShadow: "0px 4px 10px rgba(0,0,0,0.3)",
          }}
        >
          Session Expired. Please login to continue.
        </div>
      </div>
    );
  };

  const fetchSeoMetaDetails = async () => {
    try {
      const code = 'cart_page'

      const response = await fetch(`${backendUrl}${version}seo-meta-details/${code}`, {
        method: 'GET',
        headers: {
          // Accept:'aplication/json',
          "Content-Type": "application/json",

        },
        credentials: "include",
        mode: "cors"
      });

      const login = localStorage.getItem("isLoggedIn")

      if (login !== 'true') {
        setError("Access forbidden: You don't have permission to view cart items.");
        localStorage.clear()
        sessionStorage.clear()
        setCartQuantity(0)
        setShowFlashMessage(true);
        setTimeout(() => {
          navigate("/sell-used-appliances");
        }, 3000); // Redirect to login if unauthorized
        return;
      }

      if (!response.ok) {
        //console.error("Error fetching cart items:", response.status, response.statusText);

        // Handle 403 Forbidden explicitly
        if (response.status === 403) {
          setError("Access forbidden: You don't have permission to view cart items.");
          setCartQuantity(0)
          localStorage.removeItem('cartQuantity');
          sessionStorage.clear()
          localStorage.clear()

          setShowFlashMessage(true);
          setTimeout(() => {
            navigate("/sell-used-appliances");
          }, 3000);
          return;
        }
      }

      const data = await response.json();
      await changeTitleAndMetaTags(data.result.page_title, { description: data.result.meta_description, keywords: data.result.meta_tag });
    } catch (error) {
      //console.error('Error fetching categories:', error);
    }
  };

  const changeTitleAndMetaTags = async (
    title: string,
    metaTags: { description?: string; keywords?: string;[key: string]: string | undefined }
  ) => {
    try {
      // Update the document title
      if (title) {
        document.title = title;
      } else {
        document.title = "Sell Used Appliances Online in India - Instant Cash & Free Pickup | Selsmart";
      }

      // Update or create meta tags
      Object.keys(metaTags).forEach((metaName) => {
        const metaTag = document.querySelector(`meta[name="${metaName}"]`);
        if (metaTag) {
          // Update existing meta tag
          metaTag.setAttribute('content', metaTags[metaName] || `Default ${metaName} for Selsmart`);
        } else {
          // Create new meta tag if it doesn't exist
          const newMetaTag = document.createElement('meta');
          newMetaTag.name = metaName;
          newMetaTag.content = metaTags[metaName] || `Default ${metaName} for Selsmart`;
          document.head.appendChild(newMetaTag);
        }
      });

      // Cleanup function to reset the title and meta tags when unmounting
      return () => {
        document.title = "Sell Used Appliances Online in India - Instant Cash & Free Pickup | Selsmart";
        Object.keys(metaTags).forEach((metaName) => {
          const metaTag = document.querySelector(`meta[name="${metaName}"]`);
          if (metaTag) {
            metaTag.setAttribute('content', `Default ${metaName} for Selsmart`);
          }
        });
      };
    } catch (error) {
      //console.error("Error updating title and meta tags:", error);
    }
  };

  const fetchData = async (code: string) => {
    try {
      const response = await fetch(
        `${backendUrl}${version}vouchers-offers/${code}`,
        {
          method: 'GET',
          headers: {
            // Accept:'aplication/json',
            "Content-Type": "application/json",

          },
          credentials: "include",
          mode: "cors"
        }
      );
      const login = localStorage.getItem("isLoggedIn")

      if (login !== 'true') {
        setError("Access forbidden: You don't have permission to view cart items.");
        localStorage.clear()
        sessionStorage.clear()
        setCartQuantity(0)
        setShowFlashMessage(true);
        setTimeout(() => {
          navigate("/sell-used-appliances");
        }, 3000); // Redirect to login if unauthorized
        return;
      }
      const data = await response.json();

      //console.log(`Fetched Data for code ${code}:`, data); // Log the data to inspect its structure

      if (code == "top_offers") {
        //console.log("offers-------", data.data);
        setTopOffersData(data.data);
      } else {
        setTopVouchersData(data.data);
      }
    } catch (error) {
      //console.error(`Error fetching data for code ${code}:`, error);
    }
  };

  useEffect(() => {
    fetchData("top_offers");
    fetchData("top_available_vouchers");
    fetchSeoMetaDetails()
  }, []);

  const handleBrandSelect = (
    parentCatId: number,
    productId: number,
    itemId: any,
    brandTitle: string
  ) => {
    // Use a unique key based on productId and itemId
    const uniqueKey = `${productId}-${itemId}`;

    // Update the backend with the selected brand (assuming updateItemBrand is handling it)
    updateItemBrand(productId, brandTitle, itemId);

    // Update the selected brand state
    setSelectedBrands((prevState) => ({
      ...prevState,
      [uniqueKey]: brandTitle, // Update the specific item’s brand
    }));

    // Optionally update local state for the brand title (if you need it for other purposes)
    setBrandTitle(brandTitle);

    // Close the dropdown for the specific item
    setDropdownOpen((prevState) => ({
      ...prevState,
      [uniqueKey]: false, // Close dropdown for this item
    }));

    //console.log("Selected Brand:", brandTitle, "for Product ID:", productId);

    // If a valid brand is selected, reset any potential errors for this item
    if (brandTitle !== "") {
      setBrandError((prev) => ({
        ...prev,
        [uniqueKey]: false, // No error for this item
      }));
    }
  };

  // Fetch cart items
  const fetchCartItems = async () => {
    if (!sess_code) {
      return;
    }

    try {
      const response = await fetch(
        `${backendUrl}${version}cart-items/${sess_code}`,
        {
          method: 'GET',
          headers: {
            // Accept:'aplication/json',
            "Content-Type": "application/json",
            "auth-token": `${auth_token}`,

          },
          credentials: "include",
          mode: "cors"
        }
      );

      const login = localStorage.getItem("isLoggedIn")

      if (login !== 'true') {
        setError("Access forbidden: You don't have permission to view cart items.");
        localStorage.clear()
        sessionStorage.clear()
        setCartQuantity(0)
        setShowFlashMessage(true);
        setTimeout(() => {
          navigate("/sell-used-appliances");
        }, 3000); // Redirect to login if unauthorized
        return;
      }

      if (!response.ok) {
        //console.error("Error fetching cart items:", response.status, response.statusText);

        // Handle 403 Forbidden explicitly
        if (response.status === 403) {
          setError("Access forbidden: You don't have permission to view cart items.");
          localStorage.clear()
          sessionStorage.clear()
          setCartQuantity(null)
          setShowFlashMessage(true);
          setTimeout(() => {
            navigate("/sell-used-appliances");
          }, 3000);
          return;
        }

        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const result = await response.json();

      if (result.data.data.length !== 0 && Array.isArray(result.data.data)) {
        const itemsWithQuantity = result.data.data.map((item: any) => ({
          ...item,
        }));

        setCartItems(itemsWithQuantity);
        calculateTotalValue(itemsWithQuantity);
      } else {
        navigate("/sell-used-appliances");
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    } catch (err: any) {
      // console.log("cart---------",statusCode)
      setError(err.message);
    }
  };

  // Fetch cart ID
  const fetchCartId = async () => {
    if (!sess_code) {
      return;
    }

    try {
      const response = await fetch(`${backendUrl}${version}cart/${sess_code}`,
        {
          method: 'GET',
          headers: {
            // Accept:'aplication/json',
            "Content-Type": "application/json",
            "auth-token": `${auth_token}`,

          },
          credentials: "include",
          mode: "cors"
        }
      );
      if (!response.ok) {
        //console.error("Error fetching cart items:", response.status, response.statusText);

        // Handle 403 Forbidden explicitly
        if (response.status === 403) {
          setError("Access forbidden: You don't have permission to view cart items.");
          localStorage.clear()
          sessionStorage.clear()
          setCartQuantity(null)
          setShowFlashMessage(true);
          setTimeout(() => {
            navigate("/sell-used-appliances");
          }, 3000);
          return;
        }

        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const result = await response.json();
      if (result && result.data) {
        setCartId(result.data.cart_id);
      } else {
        setError("Invalid data format.");
      }
    } catch (err: any) {
      setError(err.message);
    }
  };

  const PickupFeeCheck = async (total: any) => {
    try {
      // //console.log("-----order----6786876798", selectedAddressId);

      const response = await fetch(
        `${backendUrl}${version}pickup-by-order/${total}`,
        {
          method: 'GET',
          headers: {
            // Accept:'aplication/json',
            "Content-Type": "application/json",

          },
          credentials: "include",
          mode: "cors"
        }
      );

      const login = localStorage.getItem("isLoggedIn")

      if (login !== 'true') {
        setError("Access forbidden: You don't have permission to view cart items.");
        localStorage.clear()
        sessionStorage.clear()
        setCartQuantity(0)
        setShowFlashMessage(true);
        setTimeout(() => {
          navigate("/sell-used-appliances");
        }, 3000); // Redirect to login if unauthorized
        return;
      }

      const data = await response.json();
      if (response.ok) {
        //console.log("pickup fee check --------->",data.data)
        if (data.data.showfees == true) {
          const pickupFees = data.data.pickup_fees ?? 0;
          if (totalValue !== null && totalValue < pickupFees) {
            setPickupFees(String(totalValue));
          } else {
            setPickupFees(String(pickupFees));
          }
          // setPickupFees(data.data.pickup_fees);
          if (data.data.pickup_fees == data.data.pickup_fees_global) {
            setGlobalPickupFees(data.data.pickup_fees);
          } else {
            setGlobalPickupFees(data.data.pickup_fees_global);
          }

          setFeeShow(true);
          // checkPickupFeesWaivedFromAddVoucher()
        } else {
          setFeeShow(false);
          const pickupFees = data.data.pickup_fees ?? 0;
          if (totalValue !== null && totalValue < pickupFees) {
            setPickupFees(String(totalValue));
          } else {
            setPickupFees(String(pickupFees));
          }
          // checkPickupFeesWaivedFromAddVoucher()
        }
      } else {
        if (!response.ok) {
          //console.error("Error fetching cart items:", response.status, response.statusText);

          // Handle 403 Forbidden explicitly
          if (response.status === 403) {
            setError("Access forbidden: You don't have permission to view cart items.");
            localStorage.clear()
            sessionStorage.clear()
            setCartQuantity(null)
            setShowFlashMessage(true);
            setTimeout(() => {
              navigate("/sell-used-appliances");
            }, 3000);
            return;
          }

          throw new Error(`HTTP error! Status: ${response.status}`);
        }
      }
      //   setIsPopupOpen(true);
    } catch (err: any) {
      setError("Error completing order");
    }
  };

  // Handle increase quantity
  // Handle increase quantity
  const handleIncrease = async (product_id: number, brand: any) => {
    setCartItems((prevItems) => {
      const updatedItems = prevItems.map((item) =>
        item.product_id === product_id
          ? { ...item, quantity: Number(item.quantity) + 1 } // Increment quantity
          : item
      );

      // Find the updated item to check its new quantity
      const updatedItem = updatedItems.find(
        (item) => item.product_id === product_id
      );

      if (updatedItem) {
        // Check if the new quantity exceeds 5
        if (updatedItem.quantity > 5) {
          setErrorQty("Cannot add more than 5 items of this product."); // Set error message
          return prevItems; // Return previous state without changes
        } else {
          setErrorQty(null); // Clear error if within limit
        }

        // If within limit, proceed to increase quantity in backend
        increaseItemQuantity(
          product_id,
          updatedItem.quantity,
          updatedItem.base_value,
          1,
          brand
        );
      }
      return updatedItems; // Return the updated items
    });
  };

  // Handle decrease quantity
  const handleDecrease = async (product_id: number) => {
    setCartItems((prevItems) => {
      const updatedItems = prevItems.map((item) =>
        item.product_id === product_id
          ? { ...item, quantity: Math.max(1, Number(item.quantity) - 1) } // Ensure quantity doesn't go below 1
          : item
      );

      const updatedItem = updatedItems.find(
        (item) => item.product_id === product_id
      );
      //console.log("----------updated--qty----", updatedItem?.quantity);
      // if(updatedItem?.quantity === 1){
      //     handleRemoveFromCart(product_id,-1)
      if (updatedItem && updatedItem.quantity <= 5) {
        setErrorQty(null); // Clear error if within limit
      }
      // }
      if (updatedItem) {
        decreaseItemQuantity(
          product_id,
          updatedItem.quantity,
          updatedItem.base_value,
          -1
        );
      }

      return updatedItems;
    });
  };

  const handleRemoveFromCart = async (productId: number, item_id: any) => {
    try {
      const csrfToken = await fetchCsrfToken();
      const response = await fetch(`${backendUrl}${version}delete-cart-item`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "auth-token": `${auth_token}`,
          'X-CSRF-Token': csrfToken,
        },
        credentials: "include",
        body: JSON.stringify({
          item_id: item_id,
          sess_code: sess_code,
          product_id: productId,
          quantity: 0, // Set quantity to 0 to remove item
        }),

      });

      if (!response.ok) {
        //console.error("Error fetching cart items:", response.status, response.statusText);

        // Handle 403 Forbidden explicitly
        if (response.status === 403) {
          setError("Access forbidden: You don't have permission to view cart items.");
          localStorage.clear()
          sessionStorage.clear()
          setCartQuantity(null)
          setShowFlashMessage(true);
          setTimeout(() => {
            navigate("/sell-used-appliances");
          }, 3000);
          return;
        }

        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      await fetchCartQuantity(sess_code || "defaultSessionCode");
      await fetchCartItems();
      // window.location.reload();

      // Optionally update UI or state here if needed
      //console.log("Product removed from cart");
      removeCartItemDataPerVoucher(item_id);
    } catch (error) {
      //console.error("Error removing product from cart:", error);
    }
  };

  const updateItemBrand = async (
    product_id: number,
    brand: any,
    item_id: any
  ) => {

    try {
      const csrfToken = await fetchCsrfToken();
      const response = await fetch(`${backendUrl}${version}update-item-brand`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "auth-token": `${auth_token}`,
          'X-CSRF-Token': csrfToken,
        },
        credentials: "include",
        body: JSON.stringify({
          item_id: item_id,
          product_id,
          sess_code: sess_code,
          brand: brand,
        }),

      });

      if (response.ok) {
        await fetchCartQuantity(sess_code || "defaultSessionCode");
      } else {
        throw new Error("Failed to update cart item brand");
      }
    } catch (error) {
      //console.error("Error updating cart item brand:", error);
    }
  };

  // Update item quantity in the cart
  const increaseItemQuantity = async (
    product_id: number,
    quantity: number,
    base_value: any,
    quantityChange: number,
    brandName: any
  ) => {

    try {
      const csrfToken = await fetchCsrfToken();
      const response = await fetch(`${backendUrl}${version}add-to-cart`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "auth-token": `${auth_token}`,
          'X-CSRF-Token': csrfToken,
        },
        credentials: "include",
        body: JSON.stringify({
          product_id,
          quantity,
          sess_code: sess_code,
          cart_id: cartId,
          base_value,
          brand: brandName,
        }),

      });

      if (response.ok) {
        await fetchCartQuantity(sess_code || "defaultSessionCode");
      } else {
        throw new Error("Failed to update cart item quantity");
      }
    } catch (error) {
      //console.error("Error updating cart item quantity:", error);
    }
  };

  const decreaseItemQuantity = async (
    product_id: number,
    quantity: number,
    base_value: any,
    quantityChange: number
  ) => {

    try {
      const csrfToken = await fetchCsrfToken();
      const response = await fetch(`${backendUrl}${version}remove-from-cart`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          "auth-token": `${auth_token}`,
          'X-CSRF-Token': csrfToken,
        },
        credentials: "include",
        body: JSON.stringify({
          product_id,
          quantity,
          sess_code: sess_code,
          cart_id: cartId,
          base_value,
        }),

      });

      //console.log("======", sess_code);

      await fetchCartQuantity(sess_code || "defaultSessionCode");
      await fetchCartItems();
    } catch (error) {
      //console.error("Error updating cart item quantity:", error);
    }
  };

  const handleTrashClick = (item_id: any) => {
    setSelectedItemId(item_id);
    setItemToRemove(item_id);
    setShowModal(true);
  };

  // Confirm removal
  const handleConfirmRemove = (item_id: number | null) => {
    if (itemToRemove !== null) {
      handleRemoveFromCart(itemToRemove, item_id);
    }
    setShowModal(false); // Close modal after removing
  };

  // Cancel removal
  const handleCancelRemove = () => {
    setShowModal(false);
    setItemToRemove(null); // Clear the selected item
  };

  // Calculate total value and total quantity
  const calculateTotalValue = (items: CartItem[]) => {
    const total = items.reduce(
      (acc, item) => acc + parseFloat(item.base_value) * item.quantity,
      0
    );
    const quantity = items.reduce((acc, item) => acc + item.quantity, 0);
    //         const pickupFeesValue = pickupFees ? parseFloat(pickupFees) : 0;

    // // Perform the arithmetic operation
    // const totalCartValue = total - pickupFeesValue;
    setTotalValue(total);
    PickupFeeCheck(total);
    setTotalQuantity(quantity); // Set total quantity
  };

  useEffect(() => {

    fetchCartId();
    fetchCartQuantity(sess_code || "defaultSessionCode");
    calculateTotalValue(cartItems);
    if (cartItems.length > 0) {
      //console.log("cartitemsssssssssssssssssssssssssssss", cartItems)
      preSelectedVoucherData();
    }
  }, [cartItems]);
  //console.log("--->>>user_id-------", totalValue);
  // Schedule pickup handler
  const handleSchedulePickup = async () => {
    const returnUrl = window.location.pathname;
    //console.log("--->>>user_id-------", totalValue);
    const response = await fetch(`${backendUrl}${version}check-auth`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'auth-token': `${auth_token}`
      }
    });
    if (!response.ok) {
      //console.error("Error fetching cart items:", response.status, response.statusText);

      // Handle 403 Forbidden explicitly
      if (response.status === 403) {
        setError("Access forbidden: You don't have permission to view cart items.");
        localStorage.clear()
        sessionStorage.clear()
        setCartQuantity(null)
        setShowFlashMessage(true);
        setTimeout(() => {
          navigate("/sell-used-appliances");
        }, 3000);
        return;
      }

      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    if (!user_id) {
      handleSession()
    }
    if (!user_id) {
      navigate("/login", {
        state: {
          returnUrl,
          product: product,
          session_code: sess_code,
          cart_id: cartId,
          utmQuery,
        },
      });
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      navigate("/order-summary", {
        state: {
          returnUrl,
          user_id: userId,
          cart_id: cartId,
          session_code: sess_code,
          product: product,
          utmQuery,
          selectedVouchers,
          appliedCartItemVoucher,
          totalPrice: totalValue,
        },
      });
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const handleAddMoreProduct = () => {
    if (!user_id) {
      handleSession()
    }
    navigate("/sell-used-appliances", { state: { utmQuery } });
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleSession = () => {
    const isSessionHandled = sessionStorage.getItem("sessionHandled");

    // If the session was already handled, avoid running this logic again
    if (isSessionHandled) return;

    if (checkSessionTokenExpirationStatus()) {
      // console.log("-----------Session Expired, Handling Logout");

      // Show the flash message
      localStorage.clear()
      sessionStorage.clear()
      setCartQuantity(null)
      setShowFlashMessage(true);
      setTimeout(() => {
        navigate("/sell-used-appliances");
      }, 5000);
      return;
    }
  };

  useEffect(() => {
    handleSession()
  });

  const getVouchersData = async () => {
    let product_id_array = cartItems.map((item: any) => item.product_id);
    //console.log("product_id_array", pickupFees,totalValue);
    try {
      const orderValue =
        feesShow === false
          ? totalValue
          : Number(
            (totalValue ?? 0) - (pickupFees ? parseFloat(pickupFees) : 0)
          );
      //console.log("----------->order-345-----",orderValue)
      let url = `${backendUrl}api/v2/voucher/get-order-and-item-voucher?total_cart_value=${orderValue}&product_id_array=[${product_id_array}]&user_id=${user_id}`;
      const response = await fetch(url,
        {
          method: 'GET',
          headers: {
            // Accept:'aplication/json',
            "Content-Type": "application/json",
            "auth-token": `${auth_token}`,

          },
          credentials: "include",
          mode: "cors"

        });
      const data = await response.json();
      if (response.ok) {
        //console.log("vouchers data:", data.data);
        setVouchersData(data.data);
        if (data.data.length > 0) {
          return data.data;
        } else {
          return data.data;
        }
      } else {
        if (!response.ok) {
          //console.error("Error fetching cart items:", response.status, response.statusText);

          // Handle 403 Forbidden explicitly
          if (response.status === 403) {
            setError("Access forbidden: You don't have permission to view cart items.");
            localStorage.clear()
            sessionStorage.clear()
            setCartQuantity(null)
            setShowFlashMessage(true);
            setTimeout(() => {
              navigate("/sell-used-appliances");
            }, 5000);
            return;
          }

          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        //console.error("Error fetching vouchers data:", data);
      }
    } catch (err) {
      //console.log("errrrrr", err);
    }
  };
  const preSelectedVoucherData = async () => {
    let apiVoucherData = await getVouchersData();
    let sessionSelectedVoucher = sessionStorage.getItem(
      "sessionSelectedVoucher"
    );
    //console.log("if outside sesssion stoage", sessionSelectedVoucher);
    if (sessionSelectedVoucher) {
      let selectedVoucherData = JSON.parse(sessionSelectedVoucher);
      //console.log("selectedVoucherData------->sesssion", selectedVoucherData);
      let selectedVoucher: any = [];
      //console.log("sesssion voucher data:", apiVoucherData);
      selectedVoucherData.forEach((v: any) => {
        let voucherData = apiVoucherData.find((vo: any) => vo.voucher_id === v);
        //console.log("session voucher data find out", voucherData);
        if (voucherData) {
          selectedVoucher.push(voucherData);
        }
      });
      //console.log("selectedVoucher--------session", selectedVoucher);
      setSelectedVouchers(selectedVoucher);
      // setSelectedSessionStorageVoucher(selectedVoucher);

      let appliedVouchersData = appliedVoucherWithPerticularCartItem(selectedVoucher)
      setAppliedCartItemVoucher(appliedVouchersData);
      setAppliedDummyVoucherData([...selectedVoucher]);
      if (selectedVoucher.length > 0) {
        setApplyVoucherButton(true);
        checkPickupFeesWaivedFromAddVoucher(appliedVouchersData);
      }
    } else {
      setSelectedVouchers([]);
      // setSelectedSessionStorageVoucher(selectedVoucher);

      let appliedVouchersData =
        appliedVoucherWithPerticularCartItem([]);

      setAppliedCartItemVoucher(appliedVouchersData);
      setAppliedDummyVoucherData([]);
      checkPickupFeesWaivedFromAddVoucher(appliedVouchersData);
    }
  };

  const checkPickupFeesWaivedFromAddVoucher = (appliedVoucher: any) => {
    setVoucherValueStatus(false)

    if (cartItems.length === appliedVoucher.length) {
      setPickupFeesAppliedVoucherStatus(true)
      handleValueOfCash(appliedVoucher, true);
      return true;
    } else {
      setPickupFeesAppliedVoucherStatus(false)
      handleValueOfCash(appliedVoucher, false);
      return false;
    }
  };

  const handleValueOfCash = (appliedVoucher: any, voucherStatus: boolean) => {
    if (voucherStatus) {
      setCashValueStatus(false);
      // setCashValueAmount(0);
      setCashValueAmount(
        calculateCashValueAmount(appliedVoucher, voucherStatus)
      );
    } else {
      setCashValueStatus(true);
      if (appliedVoucher.length > 0) {
        setCashValueAmount(
          calculateCashValueAmount(appliedVoucher, voucherStatus)
        );
      } else {
        setCashValueAmount(
          calculateCashValueAmount(appliedVoucher, voucherStatus)
        );
      }
    }
  };
  const calculateCashValueAmount = (appliedVoucher: any, voucherStatus: boolean) => {
    //console.log("calculateCashValueAmount====================================",);
    let cash = 0;
    let voucherValue = 0
    cartItems.forEach((item: any) => {
      let appliedVoucherdata = appliedVoucher.filter(
        (i: any) => i.cart_item_id === item.item_id
      );
      // //console.log(
      //   "pickup fesss amount data------------>",
      //   appliedCartItemVoucher,
      //   appliedVoucherdata,
      //   item.item_id
      // );

      if (appliedVoucherdata.length === 0) {
        cash += parseFloat(item.base_value) * item.quantity;
        // voucherStatus
        //   ? parseFloat(item.base_value) * item.quantity
        //   : parseFloat(item.base_value) * item.quantity -
        //    (pickupFees && feesShow ? Number(pickupFees):0);
      }

      if (appliedVoucherdata.length > 0) {
        voucherValue += parseFloat(appliedVoucherdata[0].voucher_value);
      }
    });
    setVoucherValueStatus(true)
    setVoucherValueAmount(voucherValue)
    //console.log("pickup feeess opennnnnnnnnnnnnnnnnnnnn dataaaaaaaaaaaa", feesShow, pickupFees, voucherStatus)
    // cash -= voucherStatus ? 0 : feesShow == false ? 0 : pickupFees? Number(pickupFees): 0
    return cash;
  };

  const setSelectedSessionStorageVoucher = (selectedVoucher: any) => {
    sessionStorage.setItem(
      "sessionSelectedVoucher",
      JSON.stringify(
        selectedVoucher.length === 0
          ? []
          : selectedVoucher.map((v: any) => v.voucher_id)
      )
    );
  };
  const setSessionAppliedCartItemVoucherRemove = (cart_item_id: any) => {
    let sessionAppliedRemoveCartVoucher = sessionStorage.getItem(
      "sessionAppliedRemoveCartItemVoucher"
    );

    if (sessionAppliedRemoveCartVoucher) {
      let appliedRemoveCartVoucher = JSON.parse(
        sessionAppliedRemoveCartVoucher
      );
      if (!appliedRemoveCartVoucher.includes(cart_item_id)) {
        appliedRemoveCartVoucher.push(cart_item_id);
      }
      sessionStorage.setItem(
        "sessionAppliedRemoveCartItemVoucher",
        JSON.stringify(appliedRemoveCartVoucher)
      );
    } else {
      let data = [cart_item_id];
      sessionStorage.setItem(
        "sessionAppliedRemoveCartItemVoucher",
        JSON.stringify(data)
      );
    }
  };
  let voucherMoreterms = [
    "Update your registered email to Flash.co email ID",
    "Offer valid on select payment methods",
    "Applicable on net transaction amount of ₹200",
    "Not valid for orders containing Swiggy Lite membership",
    "Cashback will be credited to Swiggy Money in 14 business days.",
    "Offer valid till Dec 31, 2024, 11:59 PM",
  ];

  const handleClose = () => {
    if (!applyVoucherButton) {
      setSelectedVouchers([]);
    }
    setVoucherPopupVisible(false);
    setItemOrOrderVoucherSelectionError("");
  };

  const handleVoucherSelection = (voucher: any) => {
    let orderLevelVoucher = 1;
    let itemLevelVoucher = 2;
    if (orderLevelVoucher === voucher.depends_on) {
      if (selectedVouchers.length === 0) {
        setSelectedVouchers([...selectedVouchers, voucher]);
      } else {
        let checkVocherStatus = checkOrderAndItemLevelVoucher(true, false);
        if (checkVocherStatus) {
          setItemOrOrderVoucherSelectionError(
            "Item voucher selected already. Please deselect the item voucher and then select order voucher"
          );
          return
        } else {
          let duplicateVoucher = checkOrderLevelVoucherDuplicate();
          //console.log("duplicateVoucher--------->", duplicateVoucher);
          if (duplicateVoucher.length > 0) {
            if (duplicateVoucher[0].voucher_id === voucher.voucher_id) {
              setSelectedVouchers(
                selectedVouchers.filter(
                  (v) => v.voucher_id !== voucher.voucher_id
                )
              );
            } else {
              setSelectedVouchers([
                ...selectedVouchers.filter(
                  (v) => v.depends_on !== orderLevelVoucher
                ),
                voucher,
              ]);
            }
          } else {
            setSelectedVouchers(
              selectedVouchers.filter(
                (v) => v.voucher_id !== voucher.voucher_id
              )
              // [voucher.identifier]
            );
          }
        }
      }
      setItemOrOrderVoucherSelectionError("");
    } else if (itemLevelVoucher === voucher.depends_on) {
      // console.log(
      //   "Order voucher selected already. Please deselect the order voucher and then select item voucher"
      // );
      if (selectedVouchers.length === 0) {
        setSelectedVouchers([...selectedVouchers, voucher]);
      } else {
        let checkItemLevelVocherStatus = checkOrderAndItemLevelVoucher(
          false,
          true
        );
        // console.log(
        //   "Order voucher selected already. else",
        //   checkItemLevelVocherStatus
        // );
        if (checkItemLevelVocherStatus) {
          setItemOrOrderVoucherSelectionError(
            "Order voucher selected already. Please deselect the order voucher and then select item voucher"
          );
          return
        } else {
          let voucherId: any = checkItemLevelVoucherProductIdDuplicate(voucher);

          if (voucherId.status) {
            if (voucherId.voucher_id === voucher.voucher_id) {
              setSelectedVouchers([
                ...selectedVouchers.filter(
                  (v: any) => v.voucher_id !== voucherId.voucher_id
                ),
              ]);

            } else {

              if (checkDisabledVoucherData(voucherId.voucher_id)) {
                setItemOrOrderVoucherSelectionError(
                  "Same voucher is already used. Please remove the same product voucher."
                );
                return;

              }
              setSelectedVouchers([
                ...selectedVouchers.filter(
                  (v: any) => v.voucher_id !== voucherId.voucher_id
                ),
                voucher,
              ]);
              // appliedVoucherWithPerticularCartItem(voucher);

            }
          } else {
            let itemVoucher = selectedVouchers.find(
              (vo) => vo.voucher_id === voucher.voucher_id
            );
            //console.log("itemVoucher", itemVoucher);
            if (itemVoucher && itemVoucher.voucher_id === voucher.voucher_id) {
              setSelectedVouchers(
                selectedVouchers.filter(
                  (v) => v.voucher_id !== voucher.voucher_id
                )
              );

            } else {
              setSelectedVouchers([...selectedVouchers, voucher]);

            }
          }
        }
      }
      setItemOrOrderVoucherSelectionError("");
    }
    // setApplyVoucherButton(false)
    //console.log("selected vouchers:", selectedVouchers);
  };

  const checkDisabledVoucherData = (voucher_id: any) => {
    let disabledVoucher = appliedDummyVoucherData.find(
      (v: any) => v.voucher_id === voucher_id
    );
    return disabledVoucher ? true : false;
  };

  const checkItemLevelVoucherProductIdDuplicate = (voucher: any) => {
    let product_id_array: any = voucher.apply_condition?.split(",");

    let check: any = { status: false, voucher_id: null };
    //console.log();
    for (let i = 0; i < product_id_array.length; i++) {
      for (let j = 0; j < selectedVouchers.length; j++) {
        let sele_product_id_array =
          selectedVouchers[j].apply_condition?.split(",");
        if (sele_product_id_array.includes(product_id_array[i])) {
          check = { status: true, voucher_id: selectedVouchers[j].voucher_id };
          break;
        }
      }
      if (check.status) {
        break;
      }
    }
    //console.log("voucher_id check duplicate", check);
    return check;
  };
  const checkOrderLevelVoucherDuplicate = () => {
    let selectedvoucher: any = selectedVouchers.filter(
      (vo) => vo.depends_on === 1
    );
    return selectedvoucher;
  };
  // const removeVoucherId = (voucher: any) => {
  //   let product_id_array: any = voucher.apply_condition?.split(",")

  //   let check = false
  //   let voucher_id:any= null
  //   for (let i = 0; i < product_id_array.length; i++){
  //     for (let j = 0; j < selectedVouchers.length; j++){
  //       let sele_product_id_array = selectedVouchers[j].apply_condition?.split(",")
  //       if (sele_product_id_array.includes(product_id_array[i])) {
  //         check = true
  //         voucher_id = selectedVouchers[j].voucher_id
  //         break
  //       }
  //     }
  //     if (check) {
  //       break
  //     }
  //   }
  //   return voucher_id

  // }

  const appliedVoucherWithPerticularCartItem = (
    selectedSessionVoucher: any,
    applyButton = true
  ) => {
    // let sessionAppliedVoucher = sessionStorage.getItem("sessionAppliedVoucher");
    // if (sessionAppliedVoucher) {
    //   sessionAppliedVoucher = JSON.parse(sessionAppliedVoucher);
    //   return sessionAppliedVoucher
    // } else {
    let sessionAppliedRemoveCartVoucher: any = sessionStorage.getItem(
      "sessionAppliedRemoveCartItemVoucher"
    );
    if (sessionAppliedRemoveCartVoucher) {
      sessionAppliedRemoveCartVoucher = JSON.parse(
        sessionAppliedRemoveCartVoucher
      );
    }
    let appliedVoucher: any = [];
    //console.log("session applied vouchers data:", selectedVouchers);
    selectedSessionVoucher.forEach((selV: any) => {
      cartItems.forEach((it: any) => {
        let product_id_array = selV.apply_condition?.split(",");
        if (product_id_array.includes(it.product_id.toString())) {
          if (sessionAppliedRemoveCartVoucher && applyButton) {
            let removeCartItem = sessionAppliedRemoveCartVoucher.filter(
              (itm: any) => itm === it.item_id
            );
            if (removeCartItem.length === 0) {
              appliedVoucher.push({
                product_id: it.product_id,
                voucher_id: selV.voucher_id,
                cart_item_id: it.item_id,
                voucher_value: selV.voucher_value
              });
            }
          } else {
            appliedVoucher.push({
              product_id: it.product_id,
              voucher_id: selV.voucher_id,
              cart_item_id: it.item_id,
              voucher_value: selV.voucher_value,
            });
          }
        }
      });
    });

    //console.log("applied voucher:---->", appliedVoucher);
    return appliedVoucher;
    // }
  };

  const checkOrderAndItemLevelVoucher = (
    orderLevel: boolean,
    itemLevel: boolean
  ) => {
    //console.log("item----order--level------", orderLevel, itemLevel);
    if (orderLevel) {
      for (let i = 0; i < selectedVouchers.length; i++) {
        let voucher: any = vouchersData.find(
          (vo: any) => vo.voucher_id === selectedVouchers[i].voucher_id
        );
        if (voucher.depends_on === 2) {
          return true;
        }
      }
      return false;
    } else if (itemLevel) {
      for (let i = 0; i < selectedVouchers.length; i++) {
        let voucher: any = vouchersData.find(
          (vo: any) => vo.voucher_id === selectedVouchers[i].voucher_id
        );
        if (voucher.depends_on == 1) {
          return true;
        }
      }
      return false;
    }
  };

  const applyVoucher = () => {
    // let appliedVoucher: any = {}
    // selectedVouchers.forEach((v: any) => {
    //   let voucher: any = vouchersData.find((vo: any) => vo.identifier === v && voucher.depends_on === 2)
    //   if (voucher) {
    //     // appliedVoucher["vou"]
    //   }
    // })
    //console.log("apply voucher data", selectedVouchers);
    if (selectedVouchers.length > 0) {
      let appliedVoucher = appliedVoucherWithPerticularCartItem(
        selectedVouchers,
        false
      );
      setAppliedCartItemVoucher(appliedVoucher);
      setAppliedDummyVoucherData([...selectedVouchers]);
      setSelectedSessionStorageVoucher([...selectedVouchers]);
      setApplyButtonRemoveVoucherData(appliedVoucher);
      checkPickupFeesWaivedFromAddVoucher(appliedVoucher);
      setVoucherPopupVisible(false);
      setApplyVoucherButton(true);
      // setCartItems([...cartItems])
    } else {
      setAppliedCartItemVoucher([]);
      setSelectedSessionStorageVoucher([]);
      checkPickupFeesWaivedFromAddVoucher([]);
      setVoucherPopupVisible(true);
      setApplyVoucherButton(false);
    }
    setItemOrOrderVoucherSelectionError("");
  };

  const setApplyButtonRemoveVoucherData = (appliedVoucher: any) => {
    let sessionAppliedRemoveCartVoucher = sessionStorage.getItem(
      "sessionAppliedRemoveCartItemVoucher"
    );
    if (sessionAppliedRemoveCartVoucher) {
      let appliedRemoveCartVoucher = JSON.parse(
        sessionAppliedRemoveCartVoucher
      );
      appliedVoucher.forEach((v: any) => {
        let removeVar = appliedRemoveCartVoucher.filter(
          (d: any) => v.cart_item_id === d
        );
        if (removeVar.length > 0) {
          appliedRemoveCartVoucher = appliedRemoveCartVoucher.filter(
            (d: any) => d !== v.cart_item_id
          );
        }
      });
      sessionStorage.setItem(
        "sessionAppliedRemoveCartItemVoucher",
        JSON.stringify(appliedRemoveCartVoucher)
      );
    }
  };
  const selectedVoucherApplied = (product_id: any, cart_item_id: any) => {
    if (applyVoucherButton) {
      // let selectedVoucher = selectedVouchers.find((vo: any) => {
      //   let product_id_array = vo.apply_condition?.split(",")
      //   return product_id_array.includes(product_id.toString())
      // })
      // if (selectedVoucher?.voucher_id) {
      //   return true
      // }
      if (selectedVouchers.length > 0) {
        let itemVoucher = appliedCartItemVoucher.find(
          (ct: any) =>
            ct.product_id === product_id && ct.cart_item_id === cart_item_id
        );
        if (itemVoucher) {
          return true;
        }
      } else {
        return false;
      }
    }
    return false;
  };
  const selectedVoucherLabel = (product_id: any) => {
    if (applyVoucherButton) {
      let selectedVoucher = selectedVouchers.find((vo: any) => {
        let product_id_array = vo.apply_condition?.split(",");
        return product_id_array.includes(product_id.toString());
      });
      if (selectedVoucher?.voucher_id) {
        return ` ${selectedVoucher.identifier} is applied `;
      }
    }
  };
  const getVoucherIdPerRemove = (product_id: any) => {
    if (applyVoucherButton) {
      let selectedVoucher = selectedVouchers.find((vo: any) => {
        let product_id_array = vo.apply_condition?.split(",");
        return product_id_array.includes(product_id.toString());
      });
      if (selectedVoucher?.voucher_id) {
        return selectedVoucher.voucher_id;
      }
    }
  };

  const removeSelectedSingleItemVoucher = (
    product_id: any,
    cart_item_id: any
  ) => {
    let appliedVoucherRemove =
      removeAppliedVoucherWithCartProductId(product_id);
    if (appliedVoucherRemove.length > 1) {
      let appliedVoucher = removeAppliedVoucherWithCartItemId(cart_item_id);
      setAppliedCartItemVoucher(appliedVoucher);
      checkPickupFeesWaivedFromAddVoucher(appliedVoucher);
      setSessionAppliedCartItemVoucherRemove(cart_item_id);
    } else {
      let appliedVoucher = removeAppliedVoucherWithCartItemId(cart_item_id);
      setAppliedCartItemVoucher(appliedVoucher);
      setSessionAppliedCartItemVoucherRemove(cart_item_id);
      let selectedVoucher = selectedVouchers.find((vo: any) => {
        let product_id_array = vo.apply_condition?.split(",");
        return product_id_array.includes(product_id.toString());
      });
      checkPickupFeesWaivedFromAddVoucher(appliedVoucher);
      if (selectedVoucher?.voucher_id) {
        let data = selectedVouchers.filter(
          (v) => v.voucher_id !== selectedVoucher.voucher_id
        );
        //console.log("removeSelectedItemVoucher------->", data);
        if (data && data.length === 0 && selectedVouchers.length === 1) {
          setSelectedVouchers([]);
          setAppliedDummyVoucherData([]);
          setSelectedSessionStorageVoucher([]);
          setApplyVoucherButton(false);
        } else if (data && data.length > 0) {
          //console.log("else if enter");
          setSelectedVouchers(data);
          setSelectedSessionStorageVoucher(data);
          setAppliedDummyVoucherData(data);
        }
      }
    }
  };
  const removeAppliedVoucherWithCartItemId = (cart_item_id: any) => {
    let appliedVoucher = appliedCartItemVoucher.filter(
      (ct: any) => ct.cart_item_id !== cart_item_id
    );

    return appliedVoucher;
  };
  const removeAppliedVoucherWithCartProductId = (product_id: any) => {
    let appliedVoucher = appliedCartItemVoucher.filter(
      (ct: any) =>
        ct.product_id === product_id ||
        ct.voucher_id === removeVoucherPerItemData.voucher_id
    );
    return appliedVoucher;
  };

  const getOrderVoucherApplied = () => {
    if (applyVoucherButton) {
      for (let i = 0; i < selectedVouchers.length; i++) {
        if (selectedVouchers[i].depends_on === 1) {
          return true;
        }
      }
    }
    return false;
  };

  const getOrderVoucherValueStatus = () => {
    if (applyVoucherButton) {
      for (let i = 0; i < selectedVouchers.length; i++) {
        if (selectedVouchers[i].depends_on === 1) {
          return true;
        }
      }
    }
    return false;
  };



  const removeSelectedAllItemVoucher = (product_id: any, cart_item_id: any) => {
    let selectedVoucher = selectedVouchers.find((vo: any) => {
      let product_id_array = vo.apply_condition?.split(",");
      return product_id_array.includes(product_id.toString());
    });
    if (selectedVoucher?.voucher_id) {
      let data = selectedVouchers.filter(
        (v) => v.voucher_id !== selectedVoucher.voucher_id
      );
      let appliedVoucher = appliedCartItemVoucher.filter(
        (ct: any) => ct.voucher_id !== selectedVoucher?.voucher_id
      );
      appliedCartItemVoucher.forEach((v: any) => {
        if (v.voucher_id === selectedVoucher?.voucher_id) {
          setSessionAppliedCartItemVoucherRemove(v.cart_item_id);
        }
      });
      setAppliedCartItemVoucher(appliedVoucher);
      checkPickupFeesWaivedFromAddVoucher(appliedVoucher);

      //console.log("removeSelectedItemVoucher------->", data);
      if (data && data.length === 0 && selectedVouchers.length === 1) {
        setSelectedVouchers([]);
        setAppliedDummyVoucherData([]);
        setSelectedSessionStorageVoucher([]);
        setApplyVoucherButton(false);
      } else if (data && data.length > 0) {
        //console.log("else if enter");
        setSelectedVouchers(data);
        setAppliedDummyVoucherData(data);
        setSelectedSessionStorageVoucher(data);
      }
    }
  };

  const removeVoucherPerItemSuccess = () => {
    let data = appliedCartItemVoucher.filter(
      (v: any) =>
        v.product_id === removeVoucherPerItemData.product_id ||
        v.voucher_id === removeVoucherPerItemData.voucher_id
    );
    if (data.length > 1) {
      setRemoveAllItemLevelVoucherPopUpStatus(true);
      setRemoveItemLevelVoucherPopUpStatus(false);
    } else {
      removeSelectedSingleItemVoucher(
        removeVoucherPerItemData.product_id,
        removeVoucherPerItemData.cart_item_id
      );
      setRemoveItemLevelVoucherPopUpStatus(false);
    }
  };

  const getApplyVoucherValue = () => {
    let value = selectedVouchers
      .map((s: any) => {
        if (s.identifier.length > 4) {
          return s.identifier;
        } else {
          return s.identifier;
        }
      })
      .join(" ,");

    return value;
  };

  const removeCartItemDataPerVoucher = (item_id: any) => {
    let appliedVoucher: any = appliedCartItemVoucher.find(
      (ct: any) => ct.cart_item_id === item_id
    );
    if (appliedVoucher) {
      let voucherData = appliedCartItemVoucher.filter(
        (v: any) => v.voucher_id === appliedVoucher.voucher_id
      );
      if (voucherData.length > 0) {
        removeSelectedSingleItemVoucher(
          appliedVoucher.product_id,
          appliedVoucher.cart_item_id
        );
      }
    }
  };

  useEffect(() => {
    if (voucherPopupVisible) {
      document.body.style.overflow = "hidden"; // Disable background scroll
    } else {
      document.body.style.overflow = ""; // Re-enable background scroll
    }

    // Cleanup function to reset scroll on component unmount
    return () => {
      document.body.style.overflow = "";
    };
  }, [voucherPopupVisible]);

  return (
    <div>
      <Header />
      {showFlashMessage && <FlashMessage message={error ?? ""} onClose={() => setShowFlashMessage(false)} />}

      <div className="section_breadcrumb">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <a href="/">Home</a>
                </li>
                <li
                  className="breadcrumb-item"
                  // aria-current="page"
                  onClick={handleAddMoreProduct}
                >
                  <a href="/sell-used-appliances">Sell Now</a>
                </li>
                <li className="breadcrumb-item">
                  <a>My Recycle Cart</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <section className="recycle_cart">
        <div className="container">
          <h2 className="text-center mb-4">My Recycle Cart</h2>
          {cartItems.length === 0 ? (
            <div className="empty-cartt-message">
              <div className="loader-cart"></div>
            </div>
          ) : (
            <div className="row">

              <div className="r_cart col-lg-8">
                {cartItems.map((item: CartItem) => (
                  <div
                    className="cart-item d-flex align-items-center p-3 mb-3"
                    key={item.item_id}
                  >
                    <img
                      src={item.img_name ? item.img_name : sellmartBulkImage} // Use fallback if img_name is unavailable
                      alt={getBannerOrImageAltTag('image', item) || "Default Alt Text"} // Fallback alt text
                      className="me-3"
                    />
                    <div className="cart_prod_info_wrap">
                      <h5 className="r_cart_prod_name">{item.title}</h5>
                      <p className="r_cart_prod_info">
                        {item.productCat.title}
                      </p>
                      <p
                        className="att_cart_prod_info"
                        dangerouslySetInnerHTML={{
                          __html: Object.entries(item.attributes)
                            .map(
                              ([key, value]) =>
                                `<div class="attr_blok"><i>${key}</i> : ${String(
                                  value
                                )}</div>`
                            )
                            .join(" "),
                        }}
                      />
                      <div className="brand_inp_wrap">
                        Brand:<span className="cosT">{item.brand}</span>
                        {/* {item?.brands && item.brands.length > 0 ? (
                                                    <select
                                                    className="form-select d-inline"
                                                    value={selectedBrands[`${item.product_id}-${item.item_id}`] || ''}
                                                    onChange={(e) =>
                                                      handleBrandSelect(item.product_id, item.product_id, item.item_id, e.target.value)
                                                    }
                                                  >
                                                    {item.brands.map((brand: any, index: number) => (
                                                      <option key={index} value={brand.title}>
                                                        {brand.title}
                                                      </option>
                                                    ))}
                                                  </select>
                                                  
                                                ) : (
                                                    <div className="select-brand-option"></div>
                                                )} */}
                      </div>
                      {/* <p className="r_cart_prod_type">Type: <span className="cosT">{item.productParent.title}</span></p> */}
                      <p className="r_cart_prod_pri">
                        Price:
                        <span className="cosT">
                          ₹ {parseFloat(item.base_value) * item.quantity}
                        </span>
                      </p>
                      {selectedVoucherApplied(
                        item.product_id,
                        item.item_id
                      ) && (
                          <p className="voucher_id_txt">
                            <i className="fa-solid fa-circle-check"></i>
                            <span>{selectedVoucherLabel(item.product_id)}</span>
                            <i
                              className="fa-solid fa-xmark"
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                // removeSelectedItemVoucher(
                                //   item.product_id,
                                //   item.item_id
                                // )
                                let voucher_id = getVoucherIdPerRemove(
                                  item.product_id
                                );
                                setRemoveVoucherPerItemData({
                                  cart_item_id: item.item_id,
                                  product_id: item.product_id,
                                  voucher_id: voucher_id,
                                });
                                setRemoveItemLevelVoucherPopUpStatus(true);
                              }}
                            ></i>
                          </p>
                        )}
                    </div>
                    {/* <svg className="svg-inline--fa fa-trash fa-w-14 ms-auto" onClick={() => handleTrashClick(item.item_id)} aria-hidden="true" focusable="false" data-prefix="fa" data-icon="trash" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" data-fa-i2svg=""><path fill="currentColor" d="M53.21 467c1.562 24.84 23.02 45 47.9 45h245.8c24.88 0 46.33-20.16 47.9-45L416 128H32L53.21 467zM432 32H320l-11.58-23.16c-2.709-5.42-8.25-8.844-14.31-8.844H153.9c-6.061 0-11.6 3.424-14.31 8.844L128 32H16c-8.836 0-16 7.162-16 16V80c0 8.836 7.164 16 16 16h416c8.838 0 16-7.164 16-16V48C448 39.16 440.8 32 432 32z"></path></svg> */}

                    <i
                      className="fa fa-trash ms-auto"
                      onClick={() => handleTrashClick(item.item_id)}
                    ></i>
                    {showModal && (
                      <div className="modal-overlays">
                        <div className="modal-contents">
                          <img
                            className="popup-trash-imagess"
                            src={trashIcon}
                            alt="Trash Icon"
                          />
                          <p className="heading-popup-trashs">
                            Are you sure you want to remove this item from the
                            cart?
                          </p>
                          <div className="modal-actionss">
                            <button
                              className="modal-remove-button"
                              onClick={() =>
                                handleConfirmRemove(selectedItemId)
                              }
                            >
                              Remove
                            </button>
                            <button
                              className="modal-cancel-button btn btn-success"
                              onClick={handleCancelRemove}
                            >
                              Cancel
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                ))}

                <button
                  className="Proceed_checkout btn btn-success"
                  onClick={handleAddMoreProduct}
                >
                  Add More Product
                </button>
              </div>


              <div className="col-lg-4">
                {topOffersData?.title && topOffersData?.html_content && (
                  <div className="cart-summary top_offer_wrap">
                    <h5>
                      <img src={voucherIconImage} alt="Icon" /> {topOffersData.title}
                    </h5>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: topOffersData.html_content,
                      }}
                    />
                    <button
                      className="show_more_top_offer"
                      type="button"
                      data-bs-toggle="modal"
                      data-bs-target="#exampleModal"
                    >
                      Show More+
                    </button>
                  </div>
                )}

                {topVouchersData?.title && topVouchersData?.html_content && (<div className="cart-summary top_offer_wrap">
                  <h5>
                    <img src={voucherIconImage} alt="Icon" />{" "}
                    {topVouchersData?.title}
                  </h5>
                  {topVouchersData?.html_content && (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: topVouchersData.html_content,
                      }}
                    />
                  )}
                  <button
                    className="show_more_top_offer"
                    type="button"
                    data-bs-toggle="modal"
                    data-bs-target="#exampleModal_2"
                  >
                    Show More+
                  </button>
                </div>)}
                <div className="cart-summary">
                  <h5>Cart Total</h5>
                  <hr />
                  <div className="Total_Amount">
                    <p>Total:</p>
                    <p>₹ {Number(totalValue ?? "0")}</p>
                  </div>
                  {/* <h2 className='quantity-total'>Subtotal ({cartItems.length} items): </h2> */}
                  <div className="dascount_Amount">
                    <p>Voucher:</p>
                    <p>
                      {getOrderVoucherApplied() ? (
                        <p
                          className="text-success order_vouch"
                          style={{ fontSize: "10px" }}
                        >
                          {`${selectedVouchers[0].identifier} `}
                          <i
                            className="fa-solid fa-xmark"
                            style={{ cursor: "pointer", fontSize: "20px" }}
                            onClick={() => {
                              setRemoveOrderLevelVoucherPopUpStatus(true);
                            }}
                          ></i>
                        </p>
                      ) : appliedCartItemVoucher.length > 0 ? (
                        <button
                          className="text-success"
                          // data-bs-toggle="modal"
                          // data-bs-target="#voucherModal"
                          onClick={() => setVoucherPopupVisible(true)}
                        >
                          Apply More Voucher
                        </button>
                      ) : (
                        <button
                          className="text-success"
                          // data-bs-toggle="modal"
                          // data-bs-target="#voucherModal"
                          // disabled ={vouchersData.length === 0?true:false}
                          onClick={() => setVoucherPopupVisible(true)}
                        >
                          Apply Voucher
                        </button>
                      )}
                    </p>
                  </div>
                  <div className="ship_Fee">
                    <p>Pickup Fee:</p>
                    {feesShow == false || pickupFeesAppliedVoucherStatus ? (
                      <p>
                        <span className="text-decoration-line-through">
                          ₹{pickupFees}
                        </span>{" "}
                        Free
                      </p>
                    ) : (
                      <p>
                        {globalpickupFees && globalpickupFees !== pickupFees ? (
                          <span className="text-decoration-line-through">
                            ₹{globalpickupFees}
                          </span>
                        ) : null}{" "}
                        {Number(pickupFees) === 0 ? "Free" : `₹${pickupFees}`}
                      </p>

                    )}
                  </div>
                  {/* <div className="ship_Fee"><p>Pickup Fee:</p><p><span className="text-decoration-line-through">₹200</span> Free</p></div> */}
                  {pickupFeesAppliedVoucherStatus ||
                    appliedCartItemVoucher.length > 0 ||
                    getOrderVoucherValueStatus() ? (
                    <div className="Total_Amount">
                      <p>Voucher Value:</p>

                      <p>
                        ₹{" "}
                        {getOrderVoucherValueStatus()
                          ? selectedVouchers[0].voucher_value
                          : voucherValueAmount}
                      </p>
                    </div>
                  ) : (
                    <div className="Payable_Amount">
                      <p>Subtotal:</p>
                      {feesShow == false ? (
                        <p>₹ {Math.max(Number(totalValue), 0)}</p>
                      ) : (
                        <p>
                          ₹{" "}
                          {Math.max(
                            Number(
                              (totalValue ?? 0) -
                              (pickupFees ? parseFloat(pickupFees) : 0)
                            ),
                            0
                          )}
                        </p>
                      )}
                    </div>
                  )}
                  {pickupFeesAppliedVoucherStatus ||
                    appliedCartItemVoucher.length > 0 ||
                    getOrderVoucherValueStatus() ? (
                    <div className="Payable_Amount">
                      <p>Pay In Cash:</p>
                      {feesShow == false ||
                        pickupFeesAppliedVoucherStatus ||
                        getOrderVoucherValueStatus() ? (
                        <p>₹ {getOrderVoucherValueStatus() ? "0" : Math.max(Number(cashValueAmount), 0)}</p>
                      ) : (
                        <p>
                          ₹{" "}
                          {Math.max(
                            Number(
                              (cashValueAmount ?? 0) -
                              (pickupFees ? parseFloat(pickupFees) : 0)
                            ),
                            0
                          )}
                        </p>
                      )}
                      {/* <p>₹ {cashValueAmount == null ? "0" : cashValueAmount}</p> */}
                    </div>
                  ) : (
                    ""
                  )}
                  {/* <div className="Total_Amount">
                  <p>Value of Voucher:</p>
                  <p>
                    ₹ {voucherValueAmount == null ? "0" : voucherValueAmount}
                  </p>
                </div>
                <div className="Payable_Amount">
                  <p>Value of cash:</p>
                  <p>₹ {cashValueAmount == null ? "0" : cashValueAmount}</p>
                </div> */}

                  <button
                    className='Proceed_checkout btn  btn-success w-100 mt-3"'
                    onClick={() => handleSchedulePickup()}
                  >
                    Proceed to checkout
                  </button>
                </div>
              </div>
              {
                voucherPopupVisible && (
                  <div className="custom-voucher-modal">
                    <div className="voucher-modal-overlay"></div>
                    <div className={`voucher-modal-content ${vouchersData.length === 0 ? "no_fix_height" : ""}`}>
                      {/* Modal Header */}
                      <div className="voucher-modal-header">
                        <h5>Available Voucher</h5>
                        <button
                          className="voucher-btn-close"
                          onClick={handleClose}
                        >
                          &times;
                        </button>
                      </div>

                      {/* Modal Body */}
                      {vouchersData.length > 0 ? (
                        <div className="voucher-modal-body">
                          <div className="apply_input_wrap position-relative">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="e.g: DAIKIN321"
                              value={getApplyVoucherValue()}
                              readOnly
                              title={getApplyVoucherValue()} // Shows full value on hover
                              style={{
                                whiteSpace: "nowrap", // Prevents text wrapping
                                overflow: "hidden", // Hides overflow
                                textOverflow: "ellipsis", // Adds "..." for overflow text
                                cursor: "pointer", // Shows a pointer to indicate hover action
                              }}
                            />
                            <button
                              className=" apply_btn btn btn-success mt-2 w-100"
                              onClick={applyVoucher}
                            >
                              Apply
                            </button>
                          </div>
                          <small className="text-success-applied d-block- mt-2">
                            <i
                              className="fa-solid fa-circle-check"
                              style={{ marginRight: "5px", fontSize: "20px" }}
                            ></i>
                            Voucher verified and will be applied at checkout.
                          </small>
                          {itemOrOrderVoucherSelectionError != "" && (
                            <small className="text-error-applied d-block- mt-2">
                              {itemOrOrderVoucherSelectionError}
                            </small>
                          )}

                          {/* Voucher List */}
                          <div className="vouchers-list">
                            {vouchersData.map((v: any, index: number) => {
                              const isSelected =
                                appliedDummyVoucherData.find(
                                  (vo: any) => vo.voucher_id === v.voucher_id
                                )?.identifier === v.identifier;
                              const isSelectedVoucher =
                                selectedVouchers.find(
                                  (vo: any) => vo.voucher_id === v.voucher_id
                                )?.identifier === v.identifier;

                              return (
                                <div
                                  key={index}
                                  className={`voucher-card ${isSelectedVoucher ? "selected-voucher" : ""
                                    } border rounded mb-3- p-3 position-relative`}
                                >
                                  <div
                                    className={`green_vertical_div ${moreButtonIndex === index ? "corner" : ""
                                      }`}
                                    style={{
                                      background: "#2e7d32",
                                      width: "60px",
                                      height: "307px",
                                      display: "flex",
                                      justifyContent: "center",
                                      alignItems: "center",
                                    }}
                                  >
                                    <svg
                                      xmlns="http://www.w3.org/2000/svg"
                                      width="40"
                                      height="40"
                                      viewBox="0 0 40 40"
                                      fill="none"
                                    >
                                      <g clip-path="url(#clip0_2708_5074)">
                                        <path
                                          d="M26.6667 0H26.45C25.7041 0.00708636 24.9817 0.261689 24.3962 0.723832C23.8106 1.18598 23.3952 1.82949 23.215 2.55333C23.022 3.25806 22.6029 3.87987 22.022 4.32309C21.4411 4.76631 20.7307 5.00639 20 5.00639C19.2693 5.00639 18.5589 4.76631 17.978 4.32309C17.3971 3.87987 16.978 3.25806 16.785 2.55333C16.6048 1.82949 16.1894 1.18598 15.6038 0.723832C15.0183 0.261689 14.2959 0.00708636 13.55 0L13.3333 0C11.124 0.00264643 9.00593 0.88147 7.4437 2.4437C5.88147 4.00593 5.00265 6.12401 5 8.33333V35C5 36.3261 5.52678 37.5979 6.46447 38.5355C7.40215 39.4732 8.67392 40 10 40H13.55C14.2959 39.9929 15.0183 39.7383 15.6038 39.2762C16.1894 38.814 16.6048 38.1705 16.785 37.4467C16.978 36.7419 17.3971 36.1201 17.978 35.6769C18.5589 35.2337 19.2693 34.9936 20 34.9936C20.7307 34.9936 21.4411 35.2337 22.022 35.6769C22.6029 36.1201 23.022 36.7419 23.215 37.4467C23.3952 38.1705 23.8106 38.814 24.3962 39.2762C24.9817 39.7383 25.7041 39.9929 26.45 40H30C31.3261 40 32.5979 39.4732 33.5355 38.5355C34.4732 37.5979 35 36.3261 35 35V8.33333C34.9974 6.12401 34.1185 4.00593 32.5563 2.4437C30.9941 0.88147 28.876 0.00264643 26.6667 0V0ZM30 36.6667L26.4283 36.5617C26.0369 35.1474 25.1897 33.9017 24.0182 33.018C22.8467 32.1342 21.4163 31.6616 19.9489 31.6736C18.4815 31.6856 17.059 32.1814 15.902 33.0841C14.7451 33.9869 13.9183 35.2462 13.55 36.6667H10C9.55797 36.6667 9.13405 36.4911 8.82149 36.1785C8.50893 35.866 8.33333 35.442 8.33333 35V28.3333H11.6667C12.1087 28.3333 12.5326 28.1577 12.8452 27.8452C13.1577 27.5326 13.3333 27.1087 13.3333 26.6667C13.3333 26.2246 13.1577 25.8007 12.8452 25.4882C12.5326 25.1756 12.1087 25 11.6667 25H8.33333V8.33333C8.33333 7.00725 8.86012 5.73548 9.7978 4.7978C10.7355 3.86012 12.0073 3.33333 13.3333 3.33333L13.5717 3.43833C13.962 4.84404 14.8017 6.08341 15.9624 6.96725C17.1231 7.8511 18.5411 8.33087 20 8.33333C21.4786 8.32075 22.9126 7.8255 24.0838 6.92294C25.2551 6.02037 26.0994 4.75991 26.4883 3.33333H26.6667C27.9928 3.33333 29.2645 3.86012 30.2022 4.7978C31.1399 5.73548 31.6667 7.00725 31.6667 8.33333V25H28.3333C27.8913 25 27.4674 25.1756 27.1548 25.4882C26.8423 25.8007 26.6667 26.2246 26.6667 26.6667C26.6667 27.1087 26.8423 27.5326 27.1548 27.8452C27.4674 28.1577 27.8913 28.3333 28.3333 28.3333H31.6667V35C31.6667 35.442 31.4911 35.866 31.1785 36.1785C30.866 36.4911 30.442 36.6667 30 36.6667Z"
                                          fill="#FCFCFD"
                                        />
                                        <path
                                          d="M21.667 25H18.3337C17.8916 25 17.4677 25.1756 17.1551 25.4882C16.8426 25.8007 16.667 26.2246 16.667 26.6667C16.667 27.1087 16.8426 27.5326 17.1551 27.8452C17.4677 28.1578 17.8916 28.3334 18.3337 28.3334H21.667C22.109 28.3334 22.5329 28.1578 22.8455 27.8452C23.1581 27.5326 23.3336 27.1087 23.3336 26.6667C23.3336 26.2246 23.1581 25.8007 22.8455 25.4882C22.5329 25.1756 22.109 25 21.667 25Z"
                                          fill="#FCFCFD"
                                        />
                                      </g>
                                      <defs>
                                        <clipPath id="clip0_2708_5074">
                                          <rect
                                            width="40"
                                            height="40"
                                            fill="white"
                                          />
                                        </clipPath>
                                      </defs>
                                    </svg>
                                  </div>
                                  {moreButtonIndex === index && (
                                    <div className="bottom_line"></div>
                                  )}
                                  <div className="d-flex- justify-content-between align-items-center">
                                    <div className="wrap_height">
                                      <div className="d-flex justify-content-between">
                                        <div className="top_voucher_id">
                                          <h6 className="mb-1">{v.identifier}</h6>
                                          <p className="text-muted small mb-0">
                                            {v.depends_on === 1
                                              ? `Get ${v.voucher_value} of order with this voucher`
                                              : `Get Item value ${v.voucher_value} with this voucher`}
                                          </p>
                                        </div>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          checked={isSelectedVoucher}
                                          disabled={isSelected ? true : false}
                                          onChange={() =>
                                            handleVoucherSelection(v)
                                          }
                                        />
                                      </div>
                                      <p className="text-muted dot_border mb-0">
                                        {v.description
                                          ? v.description.slice(0, 99)
                                          : ""}
                                      </p>
                                      {moreButtonIndex !== index &&
                                        v.description &&
                                        v.description.length > 100 && (
                                          <button
                                            className="m_button"
                                            onClick={() => {
                                              if (moreButtonIndex == null) {
                                                setMoreButtonIndex(index);
                                              } else if (
                                                moreButtonIndex === index
                                              ) {
                                                setMoreButtonIndex(null); //
                                              } else if (
                                                moreButtonIndex !== index
                                              ) {
                                                setMoreButtonIndex(index);
                                              }
                                            }}
                                          >
                                            Show More
                                          </button>
                                        )}
                                    </div>
                                    {index === moreButtonIndex && (
                                      <div className="tms_list">
                                        <h3>Term and Conditions apply</h3>
                                        <ul>
                                          <li key={0}>{v.description}</li>
                                        </ul>
                                      </div>
                                    )}
                                    {moreButtonIndex === index && (
                                      <button
                                        className="m_button lft"
                                        onClick={() => {
                                          if (moreButtonIndex == null) {
                                            setMoreButtonIndex(index);
                                          } else if (moreButtonIndex === index) {
                                            setMoreButtonIndex(null); //
                                          } else if (moreButtonIndex !== index) {
                                            setMoreButtonIndex(index);
                                          }
                                        }}
                                      >
                                        Show Less
                                      </button>
                                    )}
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      ) : (
                        <div className="no-vouchers">
                          <p>No vouchers available for this item or order.</p>
                        </div>
                      )}
                    </div>
                  </div>
                )

                //   <div
                //   className="voucher-modal"

                //   style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
                // >
                //   <div className="modal-dialog modal-dialog-centered">
                //     <div className="modal-content">

                //       <div
                //         className="modal-header"
                //         style={{ borderBottom: "none" }}
                //       >
                //         <h5 className="modal-title" id="exampleModalLabel">
                //           Apply Voucher
                //         </h5>
                //         <button
                //           type="button"
                //           className="btn-close"
                //           data-bs-dismiss="modal"
                //           aria-label="Close"
                //           data-bs-backdrop="false"
                //           onClick={() => handleClose()}
                //         ></button>
                //       </div>
                //       <div className="modal-body">
                //         <div className="mb-3">
                //           <input
                //             type="text"
                //             className="form-control"
                //             placeholder="e.g: DAIKIN321"
                //             value={selectedVouchers
                //               .map((s) => s.identifier)
                //               .join(",")}
                //             aria-label="Voucher Code"
                //           />
                //           <button
                //             className="btn btn-success mt-2 w-100"
                //             data-bs-dismiss={
                //               selectedVouchers.length > 0 ? "modal" : undefined
                //             }
                //             onClick={applyVoucher}
                //           >
                //             Apply
                //           </button>
                //           <small className="text-success d-block mt-2">
                //             Voucher verified and will be applied at checkout.
                //           </small>
                //         </div>
                //         <div className="vouchers-list">
                //           {vouchersData.map((v: any, index) => (
                //             <div
                //               key={index}
                //               className={`voucher-card ${
                //                 selectedVouchers.includes(v.identifier)
                //                   ? "border-success"
                //                   : ""
                //               } border rounded mb-3 p-3`}
                //             >
                //               <div className="d-flex justify-content-between align-items-center">
                //                 <div>
                //                   <h6 className="mb-1">{v.identifier}</h6>
                //                   <p className="text-muted small mb-0">
                //                     {v.description}
                //                   </p>
                //                 </div>
                //                 <input
                //                   type="checkbox"
                //                   className="form-check-input"
                //                   checked={
                //                     selectedVouchers.find(
                //                       (vo) => vo.voucher_id === v.voucher_id
                //                     )?.identifier === v.identifier
                //                   }
                //                   onChange={() => handleVoucherSelection(v)}
                //                 />
                //               </div>
                //               <p className="mt-2 mb-1">{v.details}</p>
                //               <button
                //                 className="btn btn-link p-0 text-decoration-none text-primary"
                //                 data-bs-toggle="collapse"
                //                 data-bs-target={`#terms-${index}`}
                //                 aria-expanded="false"

                //               >
                //                 + More
                //               </button>

                //             </div>
                //           ))}
                //         </div>
                //       </div>

                //       <div className="modal-footer">

                //       </div>
                //     </div>
                //   </div>
                //   </div>
              }
              {/* item level voucher remove modal */}

              {removeItemLevelVoucherPopUpStatus && (
                <div className="confirmation-overlay">
                  <div className="confirmation-content">
                    <h3>Item Voucher</h3>
                    <p>Are you sure you want to remove this voucher?</p>

                    <button
                      className=" canc btn btn-outline-success"
                      onClick={() => setRemoveItemLevelVoucherPopUpStatus(false)}
                    >
                      Cancel
                    </button>
                    <button
                      className="yes_s btn btn-success"
                      onClick={() => removeVoucherPerItemSuccess()}
                    >
                      Yes
                    </button>
                  </div>
                </div>
              )}
              {/* remove voucher for all item modal */}
              {removeAllItemLevelVoucherPopUpStatus && (
                <div className="confirmation-overlay">
                  <div className="confirmation-content">
                    <h3>Item Voucher</h3>
                    <p>
                      Are you sure you want to remove same voucher for all items?
                    </p>

                    <button
                      className=" canc btn btn-outline-success"
                      onClick={() => {
                        removeSelectedSingleItemVoucher(
                          removeVoucherPerItemData.product_id,
                          removeVoucherPerItemData.cart_item_id
                        );
                        setRemoveAllItemLevelVoucherPopUpStatus(false);
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      className="yes_s btn btn-success"
                      onClick={() => {
                        removeSelectedAllItemVoucher(
                          removeVoucherPerItemData.product_id,
                          removeVoucherPerItemData.cart_item_id
                        );
                        setRemoveAllItemLevelVoucherPopUpStatus(false);
                      }}
                    >
                      Yes
                    </button>
                  </div>
                </div>
              )}
              {removeOrderLevelVoucherPopUpStatus && (
                <div className="confirmation-overlay">
                  <div className="confirmation-content">
                    <h3>Order Voucher</h3>
                    <p>Are you sure you want to remove this voucher?</p>

                    <button
                      className=" canc btn btn-outline-success"
                      onClick={() => setRemoveOrderLevelVoucherPopUpStatus(false)}
                    >
                      Cancel
                    </button>
                    <button
                      className="yes_s btn btn-success"
                      onClick={() => {
                        setSelectedVouchers([]);
                        setApplyVoucherButton(false);
                        setAppliedDummyVoucherData([]);
                        setSelectedSessionStorageVoucher([]);
                        sessionStorage.setItem(
                          "sessionAppliedRemoveCartItemVoucher",
                          JSON.stringify([])
                        );
                        setRemoveOrderLevelVoucherPopUpStatus(false);
                      }}
                    >
                      Yes
                    </button>
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </section>
      <div
        className="top_offers_popup modal fade"
        id="exampleModal"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="cart-summary top_offer_wrap">
                <h5>
                  <img src={voucherIconImage} alt="Icon" />{" "}
                  {topOffersData?.title}
                </h5>
                {topOffersData?.html_content && (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: topOffersData.html_content,
                    }}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="top_offers_popup modal fade"
        id="exampleModal_2"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="cart-summary top_offer_wrap">
                <h5>
                  <img src={voucherIconImage} alt="Icon" />{" "}
                  {topVouchersData?.title}
                </h5>
                {topVouchersData?.html_content && (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: topVouchersData.html_content,
                    }}
                  />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default CartPage;
